import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { sync } from "vuex-router-sync";
import router from "@/router";
import "./filters";
import store from "@/store";
import axios from "axios";
import { loadProgressBar } from "axios-progress-bar";
import VueProgressBar from "vue-progressbar";
import VueMask from "v-mask";
import LogRocket from "logrocket";
//import { VueReCaptcha } from "vue-recaptcha-v3";

sync(store, router);

Vue.config.productionTip = false;

LogRocket.init("m61c5d/yk-billing");

Vue.use(VueMask);
Vue.use(VueProgressBar, {
    color: "#029de5",
    failedColor: "red",
    height: "1px",
});

//Vue.use(VueReCaptcha, { siteKey: "6LfTEwcbAAAAAK-P42Sh01dn--DofYk8Ih_HWelb" });

Vue.prototype.Progress = VueProgressBar;

const instance = axios.create({
    baseURL: window.location.origin.startsWith("http://localhost")
        ? "https://localhost:5001/"
        : "https://campbilling.utawapis.com/",
});

function errorHandler(error) {
    if (error.response && error.response.status == 401) {
        window.location.href = "/login";

        return;
    }

    const text =
        error.response.data && error.response.data.Message
            ? error.response.data.Message
            : "An error has occurred";

    throw new Error(text);
}

instance.interceptors.request.use(function(config) {
    config.headers.Authorization = store.state.token;

    return config;
});
instance.interceptors.response.use((response) => {
    return response ? response.data : response;
}, errorHandler);

loadProgressBar(null, instance);

Vue.prototype.$http = instance;

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
